lmApp
  .controller('TileSliderController', ['$scope', '$rootScope', '$interval', 'ShowcaseService', 'ToastService',
    function ($scope, $rootScope, $interval, ShowcaseService, ToastService) {

      $scope.namespace = 'stockmob';
      $scope.tileWithSlider = $scope.$parent.tile;
      $scope.loading = false;

      ShowcaseService.GetAvailableTiles()
        .then(function (collection) {
          $scope.tileWithSliderTypes = [];

          $scope.tileWithSliderTypes = collection
            .filter(function (item) {
              return item.type.indexOf($scope.namespace) !== -1;
            })
            .map(function (item) {
              return {
                type: 'banner',
                banner: {
                  isNew: true,
                  type: 'widget',
                  isDefaultDefined: true,
                  widget_type: item.type,
                  picture: item.picture.default,
                  bannerName: ShowcaseService._getWidgetName(item.type),
                  widget_attrs: {
                    title: _.find(item.attributes, {id: 'title'}) ? _.find(item.attributes, {id: 'title'}).default : 'Title'
                  }
                },
                isNew: true
              }
            });

          $scope.tileWithSliderTypes = $scope.tileWithSliderTypes
            .map(ShowcaseService._ParseTile)
            .filter(function (widget) {
              return ['asset', 'nop'].indexOf(widget.banner._PrivateData.widget_type) !== -1;
            });
        });

      $scope.tileWithSlider.slider._PrivateData.currentItem = 0;

      $scope.carusel = $interval(function () {
        if (!$scope.tileWithSlider._PrivateData.isExpand) {
          var len = $scope.tileWithSlider.slider.slider_items.length;
          var next = $scope.tileWithSlider.slider._PrivateData.currentItem + 1;
          $scope.tileWithSlider.slider._PrivateData.currentItem = (next < len) ? next : 0;
        }
      }, 5000);

      $scope.tileWithSlider.slider.slider_items.forEach(function (item) {
        item._PrivateData.searchResult = [];
        item._PrivateData.selectedAsset = {};
      });

      $scope.isFirst = function (slider) {
        return slider._PrivateData.currentItem === 0;
      };

      $scope.isLast = function (slider) {
        return !(slider._PrivateData.currentItem < slider.slider_items.length - 1);
      };

      $scope.prevSlider = function (slider) {
        var prev = slider._PrivateData.currentItem - 1;
        slider._PrivateData.currentItem = (prev >= 0) ? prev : 0;
      };

      $scope.nextSlider = function (slider) {
        var len = slider.slider_items.length;
        var next = slider._PrivateData.currentItem + 1;
        slider._PrivateData.currentItem = (next < len) ? next : next - 1;
      };

      $scope.isSelectedAsset = function (item, asset) {
        return item._PrivateData.selectedAsset === asset;
      };

      $scope.close = function (tile, event) {
        if (event && event.stopPropagation) event.stopPropagation();
        if (event && event.preventDefault) event.preventDefault();
        if ($scope.loading) return;

        if (tile.isNew) {
          $scope.$parent.deleteTile(tile, event)
        } else {
          $scope.$parent.collapseTile(tile);
        }
      };

      $scope.addSliderItem = function (slider, item) {
        var currentItem = angular.copy(item);

        slider._PrivateData.hasNewTile = true;

        currentItem._PrivateData.isExpand = true;
        currentItem._PrivateData.isSliderInner = true;

        slider.slider_items.push(currentItem);
        slider._PrivateData.currentItem = slider.slider_items.length - 1;

        return slider;
      };

      $scope.removeSliderItem = function (slider, index) {
        if ($scope.loading) return;

        if (slider.slider_items[index].isNew) {
          slider._PrivateData.hasNewTile = false;

          slider.slider_items.splice(index, 1);
          var newIndex = slider._PrivateData.currentItem - 1;
          slider._PrivateData.currentItem = (newIndex < 0 ) ? 0 : newIndex;

          return;
        }

        $scope.loading = true;
        $rootScope.showLinearProgress('#showcasesLoader');

        var _ids = slider.slider_items
          .filter(function (item, i) {
            return i !== index;
          })
          .map(function (item) {
            return item.id;
          });

        ShowcaseService.UpdateSlider(slider, _ids)
          .then(function (response) {
            $rootScope.hideLinearProgress('#showcasesLoader');
            $scope.loading = false;
            slider.slider_items.splice(index, 1);
            var newIndex = slider._PrivateData.currentItem - 1;
            slider._PrivateData.currentItem = (newIndex > 0 ) ? newIndex : 0;
            ToastService.Small({
              title: 'Slider item successfully deleted',
              color: 'green',
              icon: 'delete'
            });
          })
          .catch(function (reason) {
            $rootScope.hideLinearProgress('#showcasesLoader');
            ToastService.Small({
              title: 'Slider item delete failed',
              color: 'red',
              icon: 'delete'
            });
            $scope.loading = false;
            $rootScope.debugInfo(reason);
          });
      };

      $scope.createNewSliderItem = function (item) {
        if ($scope.loading) return;

        var promise;

        $scope.loading = true;
        $rootScope.showLinearProgress('#showcasesLoader');

        var slider = $scope.tileWithSlider.slider;

        var _ids = slider.slider_items
          .map(function (item) {
            return item.banner.id;
          });

        if (slider.slider_items.length > 1) {
          promise = ShowcaseService.UpdateSlider(slider, _ids);
        } else {
          promise = ShowcaseService.CreateSlider(slider, _ids)
            .then(function (response) {
              slider.id = response.slider.id;
              slider.isNew = false;
              slider._PrivateData.hasNewTile = false;
              item.isNew = false;
              $rootScope.hideLinearProgress('#showcasesLoader');
              $scope.loading = false;
              ToastService.Small({
                title: 'Slider successfully created',
                color: 'green',
                icon: 'view-carousel'
              });
              if (item._PrivateData.text) item.text = item._PrivateData.text;

              $scope.$parent.createNewTile($scope.tileWithSlider);
            });
        }

        promise
          .then(function (response) {
            slider._PrivateData.hasNewTile = false;
            item.isNew = false;
            $rootScope.hideLinearProgress('#showcasesLoader');
            $scope.loading = false;
            ToastService.Small({
              title: 'Slider item successfully created',
              color: 'green',
              icon: 'view-carousel'
            });
            if (item._PrivateData.text) item.text = item._PrivateData.text;
          })
          .catch(function (reason) {
            ToastService.Small({
              title: 'Slider item creation failed',
              color: 'red',
              icon: 'view-carousel'
            });
            $scope.loading = false;
            $rootScope.hideLinearProgress('#showcasesLoader');
            $rootScope.debugInfo(reason);
          });
      };

      $scope.slideReorder = function (slider, item, direction) {
        if ($scope.loading) return;

        var index = slider.slider_items.indexOf(item);
        var swap = null;

        if (index !== -1 && index + direction >= 0 && index + direction < slider.slider_items.length) {
          $rootScope.showLinearProgress('#showcasesLoader');
          $scope.loading = true;

          swap = slider.slider_items[index + direction];
          slider.slider_items[index + direction] = item;
          slider.slider_items[index] = swap;

          slider._PrivateData.currentItem += direction;

          var _ids = _.map(slider.slider_items, 'id');

          ShowcaseService.UpdateSlider(slider, _ids)
            .then(function (response) {
              $scope.loading = false;

              $rootScope.hideLinearProgress('#showcasesLoader');
              ToastService.Small({
                title: 'Slider\'s items successfully reordered',
                color: 'green',
                icon:  'view-carousel'
              });
            })
            .catch(function (reason) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#showcasesLoader');

              throw reason;
            });
        }
      };

      $scope.$on('$destroy', function () {
        $interval.cancel($scope.carusel);
      })
    }]);
